export type RedAlertAppearance =
    | 'border'
    | 'fill'
    | 'outline'
    | 'soft';

export type RedAlertType =
    | 'primary'
    | 'accent'
    | 'warn'
    | 'basic'
    | 'info'
    | 'success'
    | 'warning'
    | 'error';
